import { DatePipe } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, first, map, Observable, of } from 'rxjs';
import { ParamsHelper } from 'src/app/helpers/ParamsHelper';
import { HandleErrorService } from 'src/app/services/handle-error/handle-error.service';
import { Pagination } from 'src/app/shared/interfaces/pagination';
import { EmissionStatus, PsaEmissionConsultFilter, PsaEmissionConsultResponse, PsaEmissionUpdateStatus, PsaProjectEmission } from 'src/app/shared/interfaces/psa-project-emission';
import { PostApi } from 'src/app/shared/interfaces/response-api';
import { AppConfigService } from 'src/environments/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class EmissionCreditService {
  private environment: any
  private apiUrl: string;

  defaultPagination: Pagination<PsaProjectEmission> = {
    page: 1,
    size: 10,
    results: [],
    total: 0
  };

  toString = (value: any) => (value ? String(value) : '');

  constructor(
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private appConfig: AppConfigService,
    private handleErrorService: HandleErrorService
  ) {
    this.environment = this.appConfig.config;
    this.apiUrl = `${this.environment.apiIssuer}/issuances`
  }

  public projectEmissionRegister(emissionObject: PsaProjectEmission): Observable<any> {

    const body: PostApi<PsaProjectEmission> = {
      data: emissionObject
    }

    return this.httpClient.post<any>(`${this.apiUrl}`, body).pipe(
      first(),
      catchError(err => {
        return this.handleErrorService.handleError(err)
      })
    );
  }

  public projectEmissionUpdateStatus(emissionNumber:number, data:PsaEmissionUpdateStatus ): Observable<any> {

    const body: PostApi<PsaEmissionUpdateStatus> = {
      data: data
    }

    return this.httpClient.post<any>(`${this.apiUrl}/status/${emissionNumber}`, body).pipe(
      first(),
      catchError(err => {
        return this.handleErrorService.handleError(err)
      })
    );
  }

  public getNextEmissionNumber(projectId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/new?projectId=${projectId}`).pipe(
      first(),
      catchError(err => {
        console.error("Erro ao obter proximo numero de emissão do projeto")
        return this.handleErrorService.handleError(err)
      })
    );
  }

  public listCreditEmission(psaEmissionFilter?: PsaEmissionConsultFilter): Observable<PsaEmissionConsultResponse> {
    const params = new ParamsHelper(new HttpParams())
      .setParams('page', this.toString(psaEmissionFilter?.page))
      .setParams('page-size', this.toString(psaEmissionFilter?.pageSize))
      .setParams('status', this.toString(psaEmissionFilter?.status))
      .setParams('serialCode', this.toString(psaEmissionFilter?.serialCode))
      .setParams('projectName', this.toString(psaEmissionFilter?.projectName))
      .getParams();

    return this.httpClient.get<PsaEmissionConsultResponse>(`${this.apiUrl}`, {params}).pipe(
      first(),
      catchError(err => {
        return this.handleErrorService.handleError(err)
      })
    );
  }

  public getEmissionById(emissionId: Number): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/${emissionId}`).pipe(
      first(),
      catchError(err => {
        console.error("Erro ao obter emissão com id - " + emissionId)
        return this.handleErrorService.handleError(err)
      })
    );
  }

  parseEmissionStatus(allEmissions: PsaProjectEmission[]): PsaProjectEmission[] {
    allEmissions = allEmissions.map(emission => {
      switch (emission.status) {
        case 'PENDING_AUDITOR_VERIFICATION':
          emission.status = EmissionStatus.PENDING_AUDITOR_VERIFICATION;
          break;
        case 'APPROVED_BY_AUDITOR':
          emission.status = EmissionStatus.APPROVED_BY_AUDITOR;
          break;
        case 'REJECTED_BY_AUDITOR':
          emission.status = EmissionStatus.REJECTED_BY_AUDITOR;
          break;
        case 'ADJUSTED_BY_DEVELOPER':
          emission.status = EmissionStatus.ADJUSTED_BY_DEVELOPER;
          break;
        case 'PENDING_DEVELOPER_CONFIRMATION':
          emission.status = EmissionStatus.PENDING_DEVELOPER_CONFIRMATION
          break;
        case 'CONFIRMED_BY_DEVELOPER':
          emission.status = EmissionStatus.CONFIRMED_BY_DEVELOPER;
          break;
        case 'REJECTED_BY_DEVELOPER':
          emission.status = EmissionStatus.REJECTED_BY_DEVELOPER;
          break;
        case 'REGISTERED_IN_B3':
          emission.status = EmissionStatus.REGISTERED_IN_B3;
          break;
      }
      return emission;
    });

    return allEmissions;
  }
}
